// 设置页面标题
export function setDocumentTitle(content: string, isTail?: boolean): void {
  const source = document.title.split('|')
  const label = source[source.length - 1]?.trim() ?? document.title

  const title = isTail ? `${content} | ${label}` : content
  document.title = title
}
